import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from "src/components/ui/alert-dialog";

const CustomConfirmDialog = ({
	mutateFn,
	trigger,
	header = "Are you sure you want to perform this action?",
	subHeader = "Are you sure? This process cannot be undone",
	confirmButtonText = "Yes, Continue",
	confirmButtonProps,
}) => {
	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>{header}</AlertDialogTitle>
					<AlertDialogDescription>{subHeader}</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>Cancel</AlertDialogCancel>
					<AlertDialogAction {...confirmButtonProps} onClick={mutateFn}>
						{confirmButtonText}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};

export const CustomConfirmDialogWithoutTrigger = ({
	mutateFn,
	open,
	onOpenChange,
	header = "Are you sure you want to perform this action?",
	subHeader = "Are you sure? This process cannot be undone",
	confirmButtonText = "Yes, Continue",
	confirmButtonProps,
}) => {
	return (
		<AlertDialog open={open} onOpenChange={onOpenChange}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>{header}</AlertDialogTitle>
					<AlertDialogDescription>{subHeader}</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>Cancel</AlertDialogCancel>
					<AlertDialogAction {...confirmButtonProps} onClick={mutateFn}>
						{confirmButtonText}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};

export default CustomConfirmDialog;
